import {
  formatNumberToParts as getDefaultPartsFormat,
  formatNumber as getDefaultFormat
} from "base/utils";

let decimalSeparator, groupSeparator;

export const getSeparators = () => {
  let numberInParts = getDefaultPartsFormat(10000000.23);
  numberInParts.forEach((part) => {
    if (part.type === "group") {
      groupSeparator = part.value;
    } else if (part.type === "decimal") {
      decimalSeparator = part.value;
    }
  });
  if (decimalSeparator === ".") {
    decimalSeparator = decimalSeparator.replace(".", "\\.");
  }
  if (groupSeparator === ".") {
    groupSeparator = groupSeparator.replace(".", "\\.");
  }
  if (groupSeparator === " ") {
    groupSeparator = groupSeparator.replace(" ", "\\s");
  }
};

export const formatNumber = (value, decimals, currencySymbol) => {
  if (groupSeparator === undefined || decimalSeparator === undefined) {
    getSeparators();
  }
  let showNum = "";
  if (!isNaN(value) && !["", null, undefined].includes(value)) {
    showNum = getDefaultFormat(value, decimals);
  }
  if (currencySymbol && showNum) {
    showNum = `${currencySymbol} ${showNum}`;
  }
  return showNum;
};

let parseNumber = (numberString) => {
  if (groupSeparator === undefined || decimalSeparator === undefined) {
    getSeparators();
  }
  if (typeof numberString === "string") {
    if (!["", null, undefined].includes(numberString)) {
      let _numberString = numberString;
      _numberString = _numberString.replace(
        new RegExp(groupSeparator, "g"),
        ""
      );
      _numberString = _numberString.replace(
        new RegExp(decimalSeparator, "g"),
        "."
      );
      let parsedNumber = parseFloat(_numberString);
      if (!isNaN(parsedNumber)) {
        return parsedNumber;
      }
    }
    return null;
  } else if (typeof numberString === "number") {
    return numberString;
  }
};

export { parseNumber };
